var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#6D31ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9004 14.2L12.1004 14.2C10.6091 14.2 9.40039 15.4087 9.40039 16.9C9.40039 16.9 10.7504 17.5 13.0004 17.5C15.2504 17.5 16.6004 16.9 16.6004 16.9C16.6004 15.4087 15.3917 14.2 13.9004 14.2Z",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 10.6C10.9004 9.4402 11.8406 8.5 13.0004 8.5C14.1602 8.5 15.1004 9.4402 15.1004 10.6C15.1004 11.7598 14.1602 13 13.0004 13C11.8406 13 10.9004 11.7598 10.9004 10.6Z",
    stroke: "white",
    strokeWidth: 0.72,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar222);
export default __webpack_public_path__ + "static/media/avatar-22-2.6f023820cc99457f39d9d79b2cf325d7.svg";
export { ForwardRef as ReactComponent };